// pages/Page1.tsx
import { Link } from 'react-router-dom';

const Pg404 = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <div className="pagetitle">Oops, something went wrong</div>
      <p>
        :/
      </p>
      <Link to="/" className="foottitle">&#60; Back to Home</Link>
    </div>
  );
};

export default Pg404;   